export const SET_RUNTIME_VARIABLE = 'SET_RUNTIME_VARIABLE';

export const MINIMUM_DESCRIPTION_LENGTH = 3;
export const CREDENTIALS_REFRESH_BUFFER = 2 * 60 * 1000;
export const BASE_FONT_SIZE_PX = 10;
export const DEFAULT_SEARCH_SIZE = 400;
export const DEFAULT_ITERATION_COUNT = 1;
export const SAFE_TEXT = /[a-z 0-9]*/gi;

export const EMPTY_ARRAY = [];
Object.freeze(EMPTY_ARRAY);

export const EMPTY_OBJECT = {};
Object.freeze(EMPTY_OBJECT);

export const SET_MODAL_VISIBLE = 'SET_MODAL_VISIBLE';
export const SET_MODAL_PROPS = 'SET_MODAL_PROPS';
export const SET_MODAL = 'SET_MODAL';
export const MODAL = {
  ONBOARDING: 'ONBOARDING',
  LICENSE_CLIP: 'LICENSE_CLIP',
};
export const MODAL_LAYOUT = {
  BACKGROUND: 'BACKGROUND',
  FULL: 'FULL',
  EQUAL_SPLIT: 'EQUAL_SPLIT',
  LEFT: 'LEFT',
  RIGHT: 'RIGHT',
};

export const CLIP_MEDIA_VERSIONS = {
  UNGRADED_1080: 'ungraded1080',
  GRADED_1080: 'graded1080',
  UNGRADED_4K: 'ungraded4K',
  GRADED_4K: 'graded4K',
};

export const CLIP_MEDIA_VERSIONS_ORDER = [
  CLIP_MEDIA_VERSIONS.UNGRADED_1080,
  CLIP_MEDIA_VERSIONS.GRADED_1080,
  CLIP_MEDIA_VERSIONS.UNGRADED_4K,
  CLIP_MEDIA_VERSIONS.GRADED_4K,
];

export const CLIP_MEDIA_VERSION_LABELS = {
  [CLIP_MEDIA_VERSIONS.UNGRADED_1080]: '1080p ProRes - Ungraded',
  [CLIP_MEDIA_VERSIONS.GRADED_1080]: '1080p h.264 - Graded',
  [CLIP_MEDIA_VERSIONS.UNGRADED_4K]: '4K ProRes - Ungraded',
  [CLIP_MEDIA_VERSIONS.GRADED_4K]: '4K ProRes - Graded',
};

export const CLIP_MEDIA_VERSION_GRADED = {
  [CLIP_MEDIA_VERSIONS.UNGRADED_1080]: false,
  [CLIP_MEDIA_VERSIONS.GRADED_1080]: true,
  [CLIP_MEDIA_VERSIONS.UNGRADED_4K]: false,
  [CLIP_MEDIA_VERSIONS.GRADED_4K]: true,
};

export const LICENSING_STEP = {
  LICENSE_DESCRIPTION: 'LICENSE_DESCRIPTION',
  OUT_OF_LICENSES: 'OUT_OF_LICENSES',
  PICK_VERSION: 'PICK_VERSION',
  PLAN: 'PLAN',
  PAY: 'PAY',
  DOWNLOADING: 'DOWNLOADING',
};

export const ONBOARDING_STEP = {
  REGISTER: 'REGISTER',
  LOGIN: 'LOGIN',
  FORGOT_PASSWORD: 'FORGOT_PASSWORD',
  RESET_PASSWORD: 'RESET_PASSWORD',
  PLAN: 'PLAN',
  PAY: 'PAY',
  CONFIRM: 'CONFIRM',
  COMPLETE: 'COMPLETE',
};

export const PLAN = {
  BASIC: 'BASIC',
  PRO: 'PRO',
  UNLIMITED: 'UNLIMITED',
  WEBINAR: 'WEBINAR',
};

export const SET_CHOSEN_PLAN = 'SET_CHOSEN_PLAN';
export const SET_ACTIVE_PLAN = 'SET_ACTIVE_PLAN';
export const SET_COUPON_CODE = 'SET_COUPON_CODE';
export const SET_COUPON_ERROR = 'SET_COUPON_ERROR';
export const SET_PAYMENT_ERROR = 'SET_PAYMENT_ERROR';
export const SET_CHOSEN_SUMMARY = 'SET_CHOSEN_SUMMARY';
export const BEGIN_SEARCH_REQUEST = 'BEGIN_SEARCH_REQUEST';
export const UPDATE_SEARCH_REQUEST = 'UPDATE_SEARCH_REQUEST';
export const END_SEARCH_REQUEST = 'END_SEARCH_REQUEST';

export const LOAD_CLIPS = 'LOAD_CLIPS';
export const INDEX_BY_CLIP_SLUG = 'INDEX_BY_CLIP_SLUG';
export const INDEX_BY_SCENE_ID = 'INDEX_BY_SCENE_ID';
export const INDEX_BY_SCENE_SLUG = 'INDEX_BY_SCENE_SLUG';

export const LOAD_LICENSES = 'LOAD_LICENSES';
export const SET_SUBSCRIPTION = 'SET_SUBSCRIPTION';

export const SET_SEARCH_TEXT = 'SET_SEARCH_TEXT';
export const TOGGLE_FILTER_FAVORITES = 'TOGGLE_FILTER_FAVORITES';
export const TOGGLE_FILTER_LICENSED = 'TOGGLE_FILTER_LICENSED';
export const TOGGLE_SEARCH_TAG = 'TOGGLE_SEARCH_TAG';

export const SET_UI_COLORS = 'SET_UI_COLORS';
export const SET_PROFILE_IMAGE_SRC = 'SET_PROFILE_IMAGE_SRC';
export const COGNITO_LOGOUT = 'COGNITO_LOGOUT';

export const SET_SEARCH_SOURCE = 'SET_SEARCH_SOURCE';
export const SEARCH_SOURCE = {
  ALL_SCENES: 'ALL_SCENES',
  COLLECTIONS: 'COLLECTIONS',
  FEATURED: 'FEATURED',
};

export const QUERY_PARSER = {
  SIMPLE: 'simple',
  STRUCTURED: 'structured',
  LUCENE: 'lucene',
  DISMAX: 'dismax',
};
export const SORT_DIRECTION = {
  ASC: 'asc',
  DESC: 'desc',
};

export const PLAN_STATUS = {
  TRIALING: 'trialing',
  ACTIVE: 'active',
  PAST_DUE: 'past_due',
  CANCELED: 'canceled',
  UNPAID: 'unpaid',
};

export const RESPONSIVE_SIZE = {
  TINY: 0,
  PHONE: 450,
  TABLET_PORTRAIT: 600,
  TABLET_LANDSCAPE: 900,
  DESKTOP: 1200,
  LARGE_DESKTOP: 1600,
  HUGE: 2400,
};

export const MARKETING_NAV_LINKS = [
  { text: 'HOW IT WORKS', href: '/how-it-works' },
  { text: 'PRICING', href: '/pricing' },
  { text: 'BROWSE', href: '/browse' },
];

export const DASHBOARD_PAGE = {
  UPGRADE: 'upgrade',
  PROFILE: 'profile',
  LICENSES: 'licenses',
  SUBSCRIPTION: 'subscription',
};

export const DASHBOARD_TITLE = {
  upgrade: 'Upgrade To Nucleus',
  profile: 'Edit Profile',
  licenses: 'Licensed Clips',
  subscription: 'My Subscription',
};

export const FULL_STYLE = {
  position: 'absolute',
  top: 0,
  right: 0,
  bottom: 0,
  left: 0,
};



// WEBPACK FOOTER //
// ./src/constants/index.js